// import Repository from "./CeraBaseRepositoryFactory"
import Repository from "./masterRepository"
const DISPLAY_CARD_OPTIONS = "getService";
// const CREATE_ORDER = "create"
const CREATE_REQUEST = "addRequest"
const GET_REQUEST = "getRequest"
const EDIT_REQUEST="editRequest"
const ADD_COMMENTS = "addComments"
const GET_COMMENTS = "getComments"
const GET_COUPONS = "get"
const SUBMIT_COUPON = "submitCoupon"
const EDIT_COUPON = "update"
const FIND_USER = "findUser"
const EDIT_USER="editAdmin"

export default {
    getCARDOPTIONS(payload){ 
      return Repository.post(transformRoute(DISPLAY_CARD_OPTIONS),payload);
    },
    
    // createOrder(payload){
    //  return Repository.post(transformRoute1(CREATE_ORDER),payload);
//   },
    createRequest(payload){
      return Repository.post(transformRoute2(CREATE_REQUEST),payload);
    },
    getRequest(payload){
      return Repository.post(transformRoute2(GET_REQUEST),payload);
    },
    editRequest(payload){
      return Repository.post(transformRoute2(EDIT_REQUEST),payload);
  },
  addComments(payload)
  {
    return Repository.post(transformRoute3(ADD_COMMENTS),payload);
  },
  getComments(payload)
  {
    return Repository.post(transformRoute3(GET_COMMENTS),payload);
  },
  getCoupons(payload)
  {
    return Repository.post(transformRoute4(GET_COUPONS),payload);
  },
  submitCoupon(payload)
  {
    return Repository.post(transformRoute4(SUBMIT_COUPON),payload);
  },
  editCoupon(payload)
  {
    return Repository.post(transformRoute4(EDIT_COUPON),payload);
  },
  findLoggedUser(payload)
  {
    return Repository.post(transformRoute5(FIND_USER),payload);
  },
  editLoggedUser(payload)
  {
    return Repository.post(transformRoute5(EDIT_USER),payload);
  }
  
}
const transformRoute = route => {
  return `/studio/services/${route}`;
};
const transformRoute1 = route => {
    return `/studio/orders/${route}`;
};
const transformRoute2 = route => {
    return `/studio/request/${route}`;
};
const transformRoute3 = route => {
    return `/studio/comments/${route}`;
};
const transformRoute4 = route => {
    return `/miniStore/coupon/${route}`;
};
const transformRoute5 = route => {
    return `/users/${route}`;
};